"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IC3PollingV2EndpointFeatures = /** @class */ (function () {
    function IC3PollingV2EndpointFeatures() {
    }
    IC3PollingV2EndpointFeatures.Agent = "Agent";
    IC3PollingV2EndpointFeatures.MessageProperties = "MessageProperties";
    IC3PollingV2EndpointFeatures.InviteFree = "InviteFree";
    return IC3PollingV2EndpointFeatures;
}());
exports.default = IC3PollingV2EndpointFeatures;
//# sourceMappingURL=IC3PollingV2EndpointFeatures.js.map